var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CPBtn',{staticClass:"base-button",attrs:{"class-add":_vm.classname,"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }